<template lang="pug">
include /mixins

+b.no-sense-nk
  +b.i-filter__block(v-for='filter in preparedFilters', :class="{ open: isExpanded(filter.name) }")
    +e.head(@click="toggle(filter.name)" role="button" tabindex="0")
      +e.head-title
        +e.SPAN.uppercase {{ filter.title }}
    +e.body(v-if="isExpanded(filter.name)")
      tag(
        :class="{'control-descriptor--select-size_sm': filter.type === 'checkbox'}"
        :tag="widgetsMap[filter.type]"
        :value="value[filter.name]"
        :filter-name="filter.name"
        :need-display-placeholder="false"
        :filter="filter"
        @input="'range' === filter.type ? updateMultipleValues(filter.name, $event) : updateValue(filter.name, $event)"
      )

</template>

<script>
export default {
  props: {
    preparedFilters: {
      type: Array,
    },
    updateMultipleValues: {
      type: Function,
    },
    updateValue: {
      type: Function,
    },
    widgetsMap: {
      type: Object,
    },
    value: {},
  },
  data() {
    return {
      openMap: Object.create(null), // { [filterName]: true|false }
      autoOpenedMap: Object.create(null),
    };
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler() {
        (this.preparedFilters || []).forEach(f => this._ensureOpenOnce(f.name));
      },
    },
    preparedFilters: {
      immediate: true,
      handler() {
        (this.preparedFilters || []).forEach(f => this._ensureOpenOnce(f.name));
      },
    },
  },
  methods: {
    hasValue(val) {
      if (val == null) return false
      if (Array.isArray(val)) return val.length > 0
      if (val instanceof Set || val instanceof Map) return val.size > 0
      if (typeof val === 'object') return Object.keys(val).length > 0
      return String(val).length > 0
    },
    isOpen(name) {
      return !!this.openMap[name];
    },
    isExpanded(name) {
      return this.isOpen(name);
    },
    toggle(name) {
      this.$set(this.openMap, name, !this.isOpen(name));
    },
    _ensureOpenOnce(name) {
      if (this.autoOpenedMap[name]) return;
      if (this.hasValue(this.value?.[name])) {
        this.$set(this.openMap, name, true);
        this.$set(this.autoOpenedMap, name, true);
      }
    },
  },
}
</script>
